import { getRequiredConfig } from '@klpkonsern/appconfig';
import { generateRouteWithBase } from '@klpkonsern/routing';

export const hostUrl = () =>
    window.location.protocol.concat('//', window.location.host);
export const callbackUrl = (callbackRoute: string) =>
    window.location.protocol.concat('//', window.location.host, callbackRoute);

export const generateApiRoute = (
    routePath: string | Array<string | number | undefined>,
    apiVersion: string = getRequiredConfig('WEBAPP_API_VERSION'),
): string => generateRouteWithBase(routePath, apiVersion);
